import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import Tony from './images/tony.png';
import Base from './images/firebase.jpeg';
import Flutter from './images/flutter.jpeg';
import Js from './images/js.jpeg';
import Mongo from './images/mongo.jpeg';
import Python from './images/python.jpeg';
import react from './images/react.jpeg';
import Swift from './images/swift.jpeg';
import active from './images/active.png';
import design from './images/design.png';
import webH from './images/html5.png';
import mobile from './images/mobile.png';
import './App.css';

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /android|iphone|ipad|ipod/i.test(userAgent) || window.innerWidth < 768;
      setIsMobile(isMobileDevice);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <div className="mobile-warning">
        <h2>Mobile Device Not Supported</h2>
        <p>Please use a larger device such as a tablet or desktop for the best experience.</p>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="hero">
        <img className='tony' src={Tony} alt="" />
        <span>
          <h1>Hello I'm Anthony - I'm a Software Developer</h1>
        </span>
        <p>I create Mobile & Web Applications with over 5 years of experience in full-stack application <br /> development and building cloud systems.</p>
        <div className="toolbar">
          <ul className='tools'>
            <li><img src={Base} alt="" /></li>
            <li><img src={Flutter} alt="" /></li>
            <li><img src={Js} alt="" /></li>
            <li><img src={Mongo} alt="" /></li>
            <li><img src={Python} alt="" /></li>
            <li><img src={react} alt="" /></li>
            <li><img src={Swift} alt="" /></li>
          </ul>
          <div className="available">
            <img src={active} alt="" />
            <p>Available for Work</p>
          </div>
        </div>
      </div>

      <div className="exp">
        <ul>
          <li>
            <h1>+5</h1>
            <p>Years <br /> Experience</p>
          </li>
          <li>
            <h1>8</h1>
            <p>Programming <br /> Languages</p>
          </li>
          <li>
            <h1>3</h1>
            <p>Professional <br /> Jobs</p>
          </li>
        </ul>
      </div>

      <div className="skills">
        <ul>
          <li>
            <img src={design} alt="" />
            <h3>UI Design</h3>
            <p>Modern Designs, Prototyping, Inclusivity, Top-notch User Experience </p>
            <a href="https://t.me/anthonyiso">Hire Me</a>
          </li>
          <li>
            <img src={webH} alt="" />
            <h3>Web Development</h3>
            <p>Modern Designs, Prototyping, Inclusivity, Top-notch User Experience </p>
            <a href="https://t.me/anthonyiso">Hire Me</a>
          </li>
          <li>
            <img src={mobile} alt="" />
            <h3>Mobile App Development</h3>
            <p>Modern Designs, Prototyping, Inclusivity, Top-notch User Experience  </p>
            <a href="https://t.me/anthonyiso">Hire Me</a>
          </li>
        </ul>
      </div>

      <div className="me">
        <img className='tony' src={Tony} alt="" />
        <div className="txt">
          <h2>Who is Anthony Somtochukwu</h2>
          <p>An experienced Developer, Designer & Crypto Trader, with over 5 years of experience in Design and Development of Mobile and Web Applications</p>
          <a href="https://t.me/anthonyiso" className='btn'>Hire Me</a>
        </div>
      </div>
    </div>
  );
}

export default App;
